import { render, staticRenderFns } from "./bgys-report-view.vue?vue&type=template&id=f1f257aa"
import script from "./bgys-report-view.vue?vue&type=script&lang=js"
export * from "./bgys-report-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports